import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import getDate from 'date-fns/getDate'
import isSameDay from 'date-fns/isSameDay'
import isSameMonth from 'date-fns/isSameMonth'

type Props = {
  currentMonth: Date
  date: Date
  isActive: boolean
  isBefore: boolean
  isClosed: boolean
  isSpecialHoliday: boolean
  selectDate: (date: Date) => void
}

const ScheduleCollectiveCalendarCell: FC<Props> = React.memo((props) => {
  const { currentMonth, date, isActive, isBefore, isClosed, isSpecialHoliday, selectDate } = props

  const isThisMonth = isSameMonth(date, currentMonth)

  const className = (() => {
    switch (true) {
      // 当日以前の休業日が祝日
      case isThisMonth && isClosed && isBefore && isSpecialHoliday:
        return styles.table__cell__holiday_disabled
      // 当日以前の休業日
      case isThisMonth && isClosed && isBefore:
        return styles.table__cell_disabled
      // 当日以前の営業日が祝日
      case isThisMonth && !isClosed && isBefore && isSpecialHoliday:
        return styles.table__cell__holiday_before
      // 当日以前の営業日
      case isThisMonth && !isClosed && isBefore:
        return styles.table__cell_before
      // 選択状態
      case isThisMonth && isActive:
        return styles.table__cell_active
      // 当日以降の休業日・臨時休業日が祝日
      case isThisMonth && isClosed && isSpecialHoliday:
        return styles.table__cell__holiday_disabled
      // 当日以降の休業日・臨時休業日
      case isThisMonth && isClosed:
        return styles.table__cell_disabled
      // 当日が祝日
      case isThisMonth && isSameDay(date, new Date()) && isSpecialHoliday:
        return styles.table__cell__holiday_today
      // 今日の日付
      case isThisMonth && isSameDay(date, new Date()):
        return styles.table__cell_today
      case isThisMonth && isSpecialHoliday:
        return styles.table__cell__holiday
      default:
        return styles.table__cell
    }
  })()

  const onClickDate = () => {
    if (!isThisMonth || isBefore) {
      return null
    } else if (isClosed) {
      return null
    } else {
      selectDate(date)
    }
  }

  return (
    <td className={className} onClick={onClickDate}>
      <span className={styles.table__cell__date}>{isThisMonth ? getDate(date) : ''}</span>
    </td>
  )
})

export default ScheduleCollectiveCalendarCell
